const ThemeColors = [
    '#28ff65', // 0  IPSA Green
    '#392395', // 1  used for assets
    '#61B1E4', // 2
    '#7FFAFF', // 3
    '#C7A1E3', // 4
    '#A86FD3', // 5
    '#8470D0', // 6
    '#00F6FF', // 7  Toolbox light blue
    '#1E90D9', // 8  Training purple
    '#3B2BB3', // 9  Insights Purple
    '#0f0835', // 10 background, dark
    '#2d197d', // 11 background, light
    '#0A0525', // 12 background, darker
    '#D8D5F0', // 13 light greyish purple
    '#3a2ab3', // 14 Group Coverage
    '#1e8fd9', // 15 Individucal Coverage
    '#6A29C9', // 16 benefit vs premium purple
    '#FF0066', // 17 benefit vs premium pink/red,
    '#990033', // 18 used for individual premium, supplemental basic premium
    '#660033', // 19 used for group premium, supplemental moderate premium
    '#CC0066', // 20 used for comprehensive premium, supplemental comprehensive premium
    '#FFFFFF', // 21 white
    '#FF3788', // 22 benefit vs premium light pink,
    '#524BD5', // 23 benefit vs premium income protection value,
    '#302AB3', // 24 benefit vs premium consolidated asset value,
    '#c5fdd6', // 25 cat benefit
    '#261b75', // 26 Group STD Coverage
    '#420121', // 27 Group STD premium
    '#FF0000', // 28 Loss Red
    '#7cfca2', // 29 Supplemental benefit green
    '#4b0628', // 30 red for the bacground of income loss
]

const IpsaGreen = ThemeColors[0]
const ToolboxBlue = ThemeColors[7]
const TrainingPurple = ThemeColors[8]
const InsightsPurple = ThemeColors[9]
const DarkBackgroundColor = ThemeColors[10]
const LightBackgroundColor = ThemeColors[11]
const DarkerBackgroundColor = ThemeColors[12]
const IpsaGreyPurple = ThemeColors[13]
const GroupCoveragePurple = ThemeColors[14]
const GroupStdCoveragePurple = ThemeColors[26]
const IndividualCoveragePurple = ThemeColors[15]

const IpsaAssets = ThemeColors[1]
const IpsaIndividualPremium = ThemeColors[18]
const IpsaGroupPremium = ThemeColors[19]
const IpsaGroupStdPremium = ThemeColors[27]
const IpsaComprehensivePremium = ThemeColors[20]

const IpsaSupplementalBenefitColor = ThemeColors[29]
const IpsaBasicSupplementalBenefit = IpsaSupplementalBenefitColor
const IpsaModerateSupplementalBenefit = IpsaSupplementalBenefitColor
const IpsaComprehensiveSupplementalBenefit = IpsaSupplementalBenefitColor
const IpsaCatSupplementalBenefit = ThemeColors[25]

const BenefitVsPremiumCoverage = ThemeColors[16]
const BenefitVsPremiumPremium = ThemeColors[17]
const IncomeProtectionPremium = ThemeColors[22]
const IncomeProtectionValue = ThemeColors[23]
const ConsolidatedAssetValue = ThemeColors[24]

const IpsaWhite = ThemeColors[21]
const IpsaRed = ThemeColors[28]

const DarkRedBackground = ThemeColors[30]

const ColorWithOpacity = (hex, opacity) => {
    return hexToRgbA(hex, opacity)
}

const StyleSeries = (series) => {
    if (typeof series !== 'object' || series === null) {
        return series
    }

    let setColor = 'yellow'

    switch (series.styleType) {
        case 'Income':
            setColor = IpsaGreen
            series.className = ''
            break
        case 'Assets':
            setColor = IpsaAssets
            series.className = ''
            break
        case 'DeficitRed':
            setColor = DarkRedBackground
            series.className = 'highchart-series-deficit-red'
            break
        case 'DeficitYellow':
            setColor = DarkBackgroundColor
            series.className = 'highchart-series-deficit-yellow'
            break
        case 'DeficitGreen':
            setColor = DarkBackgroundColor
            series.className = 'highchart-series-deficit-green'
            break
        case 'DeficitWhite':
            setColor = DarkBackgroundColor
            series.className = 'highchart-series-deficit-white'
            break
        case 'IndividualCoverageBenefit':
            setColor = IndividualCoveragePurple
            series.className = ''
            break
        case 'GroupCoverageBenefit':
            setColor = GroupCoveragePurple
            series.className = ''
            break
        case 'GroupStdCoverageBenefit':
            setColor = GroupStdCoveragePurple
            series.className = ''
            break
        case 'SupplementalCoverageBenefit':
            setColor = InsightsPurple
            series.className = ''
            break
        case 'SupplementalCoverageCost':
            setColor = IpsaComprehensivePremium
            series.className = ''
            break
        case 'IndividualCoverageCost':
            setColor = IpsaIndividualPremium
            series.className = ''
            break
        case 'GroupCoverageCost':
            setColor = IpsaGroupPremium
            series.className = ''
            break
        case 'GroupStdCoverageCost':
            setColor = IpsaGroupStdPremium
            series.className = ''
            break

        case 'ComprehensiveCoverageBenefit':
            setColor = IpsaComprehensiveSupplementalBenefit
            series.className = ''
            break
        case 'ModerateCoverageBenefit':
            setColor = IpsaModerateSupplementalBenefit
            series.className = ''
            break
        case 'BasicCoverageBenefit':
            setColor = IpsaBasicSupplementalBenefit
            series.className = ''
            break

        case 'CatSupplementalBenefit':
            setColor = IpsaCatSupplementalBenefit
            series.className = ''
            break

        case 'BenefitVsPremiumCoverage':
            setColor = BenefitVsPremiumCoverage
            series.className = ''
            break
        case 'BenefitVsPremiumPremium':
        case 'ConsolidatedAssetPremium':
            setColor = BenefitVsPremiumPremium
            series.className = ''
            break
        case 'IncomeProtectionPremium':
            setColor = IncomeProtectionPremium
            series.className = ''
            break
        case 'IncomeProtectionValue':
            setColor = IncomeProtectionValue
            series.className = ''
            break
        case 'ConsolidatedAssetValue':
            setColor = ConsolidatedAssetValue
            series.className = ''
            break

        case 'CurrentCoverageBenefit':
            setColor = IpsaWhite
            series.className = ''
            break

        case 'IncomeLoss':
            setColor = DarkBackgroundColor
            series.className = 'highchart-series-deficit-white-label'
            break

        default:
            setColor = IpsaGreen
            series.className = ''
    }

    series.color = setColor
    return series
}

/**
 * Will style the drilldown with ThemeStyles skipping the income neon green.
 * @param {drilldown} drilldown
 */
const StyleDrilldownDataPoints = (drilldown, colorIndex = 0) => {
    for (let i = 0; i < drilldown.data.length; i++) {
        let drilldownData = drilldown.data[i]
        drilldownData.color = ThemeColors[i + colorIndex]
    }
    return drilldown
}

/**
 * On the benefit Cost Comparison graph the API returns null data and because of that
 * when the chart opts get merged together the old values would stay because there
 * is no new y value in the data object.
 *
 * basically turning the data object from {name: "name"} to {name: "name", y: null}
 */
const SetEmptyYValuesToNull = (series) => {
    if (series.data) {
        series.data = series.data.map((dataPoint) => {
            if (!dataPoint.y) {
                dataPoint.y = null
            }
            return dataPoint
        })
    }

    return series
}

////////////////////////////
//////// PRIVATE CONST /////
////////////////////////////

const hexToRgbA = (hex, opacity = 1) => {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        let c = hex.substring(1).split('')
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')'
    }
    throw new Error('Bad Hex')
}

export {
    StyleDrilldownDataPoints,
    StyleSeries,
    SetEmptyYValuesToNull,
    ColorWithOpacity,
    IpsaGreen,
    ToolboxBlue,
    TrainingPurple,
    InsightsPurple,
    DarkBackgroundColor,
    LightBackgroundColor,
    DarkerBackgroundColor,
    IpsaRed,
    IpsaGreyPurple,
    ThemeColors,
    IpsaWhite,
    IpsaBasicSupplementalBenefit,
    IpsaModerateSupplementalBenefit,
    IpsaComprehensiveSupplementalBenefit,
    IpsaSupplementalBenefitColor,
}
